<template lang="html">
  <div class="profile-notifications-wrapper">
    <Notifications />
  </div>
</template>

<script>
import Notifications from "@/components/profile/notifications.vue";
export default {
  name: "profileNotifications",
  components: {
    Notifications
  }
};
</script>

<style lang="scss" scoped>
.profile-notifications-wrapper {
  padding-left: 40px;
}
@media screen and (max-width: 1000px) {
  .profile-notifications-wrapper {
    padding-left: 5px;
  }
}
</style>
